module.exports = __webpack_public_path__ + "img/hierarchy.7789abc4.svg";